import generateCartIdentifier from './generateCartIdentifier';

interface IResolveCartIdentifierParams {
  current: string | null;
  ownerId: number | null;
  customerId: number;
}

export default function resolveCartIdentifier({
  current,
  ownerId,
  customerId,
}: IResolveCartIdentifierParams): string {
  if (!current) return generateCartIdentifier();
  if (ownerId !== null && ownerId !== customerId) {
    return generateCartIdentifier();
  }

  return current;
}
